"use strict";

var __extends = this && this.__extends || function () {
  var extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) {
      if (b.hasOwnProperty(p)) d[p] = b[p];
    }
  };

  return function (d, b) {
    extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || Object.assign || function (t) {
  for (var s, i = 1, n = arguments.length; i < n; i++) {
    s = arguments[i];

    for (var p in s) {
      if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
  }

  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var closeSvg = require("../../../icons/close-16.svg");

var font_1 = require("@headspace/hs-web-style-guide/dist/font");

var styles_1 = require("./styles");

var Icon_1 = require("../../../icons/Icon");

var colors_1 = require("@headspace/hs-web-style-guide/dist/colors");

var FullTableToast =
/** @class */
function (_super) {
  __extends(FullTableToast, _super);

  function FullTableToast() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  FullTableToast.prototype.render = function () {
    var _a = this.props,
        sortedRows = _a.sortedRows,
        isRowSelected = _a.isRowSelected,
        selectHeaderRow = _a.selectHeaderRow,
        toastAction = _a.toastAction,
        toastActionText = _a.toastActionText;
    var rowsCount = sortedRows.filter(function (row) {
      return isRowSelected(row);
    }).length;
    return React.createElement("div", __assign({
      className: "showSelectedToast"
    }, styles_1.toastWrapperStyle), React.createElement("div", __assign({}, styles_1.toastStyle, font_1.regular), React.createElement("div", __assign({}, styles_1.toastGroupStyle), React.createElement("div", __assign({
      onClick: function onClick() {
        return selectHeaderRow();
      }
    }, styles_1.closeToastStyle), React.createElement(Icon_1.Icon, {
      width: 16,
      height: 16,
      fill: colors_1.white,
      src: closeSvg
    })), React.createElement("div", __assign({}, styles_1.toastGroupStyle), React.createElement("div", __assign({}, styles_1.rowsCountStyle), rowsCount), React.createElement("div", null, "selected"))), toastAction && toastActionText ? React.createElement("div", __assign({
      className: "showSelectedToastAction",
      onClick: function onClick() {
        return toastAction();
      }
    }, styles_1.unselectRowsStyle, font_1.regular), toastActionText) : null));
  };

  return FullTableToast;
}(React.Component);

exports.FullTableToast = FullTableToast;